var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/web.immediate.js
// module id = ./node_modules/core-js/modules/web.immediate.js
// module chunks = 53 54